export const USDI_YONA_USERNAME = 'usdi_yona';

export const NOTIFICATION_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'alerts', label: 'Alerts' },
  { id: 'buddies', label: 'Buddies' },
];

export const ALERT_NOTIFICATION_TYPES = new Set([
  'feeder_low',
  'listing_expiring_soon',
  'parcel_request_ready',
  'map_print_status',
  'store_inventory_update',
  'club_join_request',
  'club_join_decision',
  'club_member_invite',
  'club_member_invite_decision',
  'processor_listing_approved',
  'processor_listing_rejected',
  'club_feed_filled',
  'club_feed_low',
  'club_plan_shared',
]);

export const NOTIFICATIONS_CHANGED_EVENT = 'yona:notifications-changed';
